import Environment from './environment';

export default class Logger {
  debug: boolean;

  constructor() {
    this.debug = Environment.getEnvironment() === Environment.dev();
  }

  log(msg: string, title='') {
    if (this.debug) {
      console.log(msg, title);
    }
  }

  warn(msg: string) {
    if (this.debug) {
      console.warn(msg);
    }
  }

  error(msg: string, title='') {
    if (this.debug) {
      console.error(msg, title);
    } else {
      // @todo: track error somewhere
    }
  }
}
